import React from 'react'
import Checkbox, {CheckboxProps} from '@mui/material/Checkbox'
import styled from 'styled-components'
import checkboxStyles from './checkbox.styles'

interface ApCheckBoxProps extends CheckboxProps {
  ap_type?: 'none'
}

const apAtomName = {ap_atom_name: 'checkboxAtom'}

const CheckboxAtom = styled((props: ApCheckBoxProps) => (
  <Checkbox {...apAtomName} {...props} />
))`
  ${checkboxStyles}
`

export default CheckboxAtom
